// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"536":"62dc9b68","9048":"01e5311c"}[chunkId] || chunkId) + "." + {"536":"0d1e0e40291a5dd7","4596":"f2c0247820e73882","4825":"6e3e13332c080eb7","8270":"96d995992893459d","9048":"fb8b64a602cb3172"}[chunkId] + ".js";
};